import presignedExport from "../../../services/auth/presignedExport";

export const auditApi = {
  getAIReviewResponseAuditReport: async () => await presignedExport.downloadExport("/v6/airesponse/auditReport"),
};
